'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBalloon = function MessageBalloon(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react2.default.createElement(
    'svg',
    { width: size, height: size, viewBox: '0 0 64 64' },
    _react2.default.createElement('circle', { cx: '32', cy: '32', r: '32', fill: color }),
    _react2.default.createElement('path', {
      d: 'M17,30.7171459 C17,23.1379775 23.7201318,17 32,17 C40.2798682,17 47,23.1379775 47,30.7171459 C47,38.2963142 40.2798682,44.4497917 32,44.4497917 C30.214965,44.4497917 24.5001471,48.479473 22.9101159,47.9524749 C21.7100924,47.5497803 24.5901488,42.713798 23.5401282,42.0628004 C19.5950509,39.5828095 17,35.4291286 17,30.7171459 Z M37.9652709,26 L26.0347291,26 C25.6168719,26 25.2758621,26.2 25.2758621,26.45 L25.2758621,27.55 C25.2758621,27.8 25.6168719,28 26.0347291,28 L37.9652709,28 C38.3831281,28 38.7241379,27.8 38.7241379,27.55 L38.7241379,26.45 C38.7241379,26.2 38.3831281,26 37.9652709,26 Z M37.9652709,30 L26.0347291,30 C25.6168719,30 25.2758621,30.2 25.2758621,30.45 L25.2758621,31.55 C25.2758621,31.8 25.6168719,32 26.0347291,32 L37.9652709,32 C38.3831281,32 38.7241379,31.8 38.7241379,31.55 L38.7241379,30.45 C38.7241379,30.2 38.3831281,30 37.9652709,30 Z M31.7583566,34 L26.034554,34 C25.6167933,34 25.2758621,34.2 25.2758621,34.45 L25.2758621,35.55 C25.2758621,35.8 25.6167933,36 26.034554,36 L31.7583566,36 C32.1761174,36 32.5170486,35.8 32.5170486,35.55 L32.5170486,34.45 C32.5266523,34.2 32.1761174,34 31.7583566,34 Z',
      fill: '#FFFFFF'
    })
  );
};

MessageBalloon.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

MessageBalloon.defaultProps = {
  size: 64,
  color: '#B7C1C4'
};

exports.default = MessageBalloon;